// import on your project (less then 1KB gziped)
// https://github.com/Yuliang-Lee/vue2-smooth-scroll#readme

import Vue from "vue";
import VueSmoothScroll from "vue2-smooth-scroll";
Vue.use(VueSmoothScroll, {
    duration: 400,
    updateHistory: false
});
